import Link from "next/link";

import { CSSObject } from "@emotion/react";
import {
  Anchor,
  Badge,
  Icon,
  LockHollowSVG,
  type SvgComponentType,
} from "@newsela/angelou";
import {
  anchorCss,
  iconAndTitleCss,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/PopoutMenuSection/PopoutMenuSection.styles";
import {
  badgeCss,
  menuItemIcon,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/PopoutSectionItemWithPopout/PopoutSectionItemWithPopout.styles";
import formatHrefToSupportLegacyLink from "@/utils/formatHrefToSupportLegacyLink";

const PopoutSectionItem = ({
  href,
  title,
  SvgComponent,
  locked = false,
  openInNewTab = false,
  dataQASelector = "",
  rootCss = {},
  badge,
  onClick,
}: IPopoutMenuItem) => {
  return (
    <li css={rootCss}>
      <Link href={formatHrefToSupportLegacyLink(href)} passHref legacyBehavior>
        <Anchor
          __cssFor={anchorCss}
          openInNewTab={openInNewTab}
          dataProps={{ "data-qa-selector": dataQASelector }}
          onClick={() => onClick?.(title ?? "")}
        >
          <div css={iconAndTitleCss}>
            {locked && (
              <Icon
                SvgComponent={LockHollowSVG}
                __cssFor={menuItemIcon}
                dataProps={{ "data-testid": "locked-popout-menu-item" }}
              />
            )}
            {!locked && SvgComponent && (
              <Icon
                SvgComponent={SvgComponent}
                __cssFor={menuItemIcon}
                dataProps={{ "data-testid": "unlocked-popout-menu-item" }}
              />
            )}

            {title}
          </div>

          {badge && (
            <Badge
              hideIcon
              text={badge}
              __cssFor={badgeCss}
              size={Badge.size.md}
              flavor={Badge.flavor.solid}
            />
          )}
        </Anchor>
      </Link>
    </li>
  );
};

interface IPopoutMenuItem {
  href: string;
  badge?: string | undefined;
  title: string | undefined;
  rootCss?: CSSObject;
  locked?: boolean;
  dataQASelector?: string;
  openInNewTab?: boolean | undefined;
  SvgComponent?: SvgComponentType;
  onClick?: (title: string) => void;
}

PopoutSectionItem.displayName = "PopoutSectionItem";
export { PopoutSectionItem };
